module.exports = __webpack_public_path__ + "img/listteacher.d7c1ce62.svg";